import { api } from '@xtnd/web/shared/api';
import { fileUtil } from '@xtnd/web/shared';

export interface EscalationReportItem {
  responsibleAttorney: string;
  dateCollectionAttemptLogged: string;
  administrativeSelection: string;
  escalatedBy: string;
  comments: string;
  invoiceNumber: string;
  outstandingArBalance: number;
  matterTotalAr: number;
  matterNumber: string;
  matterName: string;
  clientName: string;
  originatingAttorney: string;
  adjusterName: string;
  adjusterEmail: string;
  adjusterPhoneNumber: string;
}

export interface EscalationReportResponse {
  data: EscalationReportItem[];
  total: number;
}

class EscalationReportService {
  private readonly baseResource = '/ar-collections/escalation-report';

  async getEscalationReport(): Promise<EscalationReportResponse> {
    return await api.get<EscalationReportResponse>(this.baseResource);
  }

  async exportExcel(): Promise<string> {
    const endpoint = `${this.baseResource}/export`;
    const fileData = await api.get<Blob>(endpoint);
    const base64 = await fileData.text();

    await fileUtil.downloadBase64(
      base64,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'escalation-report',
    );

    return 'success';
  }
}

export const reportingEscalationApi = new EscalationReportService();
